import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { abbrNumberFilter } from "app/filters/ngFilters";

import type { IRawDataMetrics } from "../search-trends-page/demand-size/types";

import { SearchVolumeOverTimeChangeIndicator } from "./SearchVolumeOverTimeChangeIndicator";
import { SearchVolumeOverTimeLoaderSkeleton } from "./SearchVolumeOverTimeLoaderSkeleton";

const TotalVolumeValue = styled.h3`
    ${setFontVariant("h3", colorsPalettes.carbon[500])}
    font-family: "DM Sans";
    margin-bottom: 4px;
`;

const volumeNumberFormatter = (value: number) => abbrNumberFilter()(value);

type SearchVolumeOverTimeChangeMetricsProps = {
    isLoading: boolean;
    data: IRawDataMetrics;
};

export const SearchVolumeOverTimeChangeMetrics = ({ isLoading, data }: SearchVolumeOverTimeChangeMetricsProps) => {
    if (isLoading) {
        return <SearchVolumeOverTimeLoaderSkeleton />;
    }

    return (
        <>
            <TotalVolumeValue>{volumeNumberFormatter(data?.Volume?.Value)}</TotalVolumeValue>
            <SearchVolumeOverTimeChangeIndicator
                isLoading={isLoading}
                changeValue={data?.Volume?.Change}
                volumeGrowth={data?.TotalScore}
            />
        </>
    );
};
